import removeNamespace from "../namespace-helper"
// import axios from "../../plugins/axios";

export const Types = {
  getters: {
    TABS: "application/TABS",
    INDEX: "application/INDEX",
  },
  actions: {
    UPDATE_TABS: "application/UPDATE_TABS",
    UPDATE_INDEX: "application/UPDATE_INDEX",
    UPDATE_HELP_VISIBILITY: "application/UPDATE_HELP_VISIBILITY",
    UPDATE_MENU_STYLE: "application/UPDATE_MENU_STYLE",
  },
  mutations: {
    UPDATE_TABS: "application/UPDATE_TABS",
    UPDATE_INDEX: "application/UPDATE_INDEX",
    UPDATE_HELP_VISIBILITY: "application/UPDATE_HELP_VISIBILITY",
    UPDATE_MENU_STYLE: "application/UPDATE_MENU_STYLE",
  },
}

const _types = removeNamespace("application/", Types)

const state = {
  index: 0,
  tabs: [
    {
      singleton: true,
      locked: true,
      name: "Menu",
      icon: "sr-fa-home",
      component: "Menu",
      class: "col-1",
    },
  ],
  helpIsVisible: true,
  menuStyles: {
    GRID: 0,
    ROW: 1,
  },
  currentMenuStyle: 0,
}

// getters
const getters = {
  [_types.getters.TABS]: state => state.tabs,
  [_types.getters.INDEX]: state => state.index,
}

// actions
const actions = {
  [_types.actions.UPDATE_TABS]: ({ commit, state }, tabs) => {
    return new Promise(resolve => {
      const previousVersion = { ...state.tabs }

      commit(_types.mutations.UPDATE_TABS, tabs)

      resolve(previousVersion)
    })
  },
  [_types.actions.UPDATE_INDEX]: ({ commit, state }, index) => {
    return new Promise(resolve => {
      const previousVersion = { ...state.index }

      commit(_types.mutations.UPDATE_INDEX, index)

      resolve(previousVersion)
    })
  },
  [_types.actions.UPDATE_HELP_VISIBILITY]: ({ commit }, isVisible) => {
    commit(_types.mutations.UPDATE_HELP_VISIBILITY, isVisible)
  },
  [_types.actions.UPDATE_MENU_STYLE]: ({ commit }, menuStyle) => {
    commit(_types.mutations.UPDATE_MENU_STYLE, menuStyle)
  },
}

// mutations
const mutations = {
  [_types.mutations.UPDATE_TABS]: (state, tabs) => {
    state.tabs = tabs
  },
  [_types.mutations.UPDATE_INDEX]: (state, index) => {
    state.index = index
  },
  [_types.mutations.UPDATE_HELP_VISIBILITY]: (state, isVisible) => {
    state.helpIsVisible = isVisible
  },
  [_types.mutations.UPDATE_MENU_STYLE]: (state, menuStyle) => {
    state.menuStyle = menuStyle
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
